import React, { createContext, Component } from 'react'
import PropTypes from 'prop-types'

const context = createContext({})

export const { Consumer, Provider } = context

class Container extends Component {
	state = Container.getDerivedStateFromProps(this.props, {}) || {}

	static getDerivedStateFromProps = (nextProps, prevState) =>
		nextProps.position !== prevState.position ? { position: nextProps.position } : null

	render = () => <Provider value={this.state}>{this.props.children}</Provider>

	static propTypes = {
		position: PropTypes.number,
		children: PropTypes.any
	}
}

export default Container
